import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { counterData } from '../data/Counters';
import { useStaticQuery, graphql, Link } from 'gatsby';

import counterImg from '../images/counter_img.jpg';

import { useCountUp } from 'react-countup';
import useCounters from '../hooks/useCounters';

export const HomeCounters = () => {
  const { counters } = useCounters();
  const { countUp: countOne } = useCountUp({ end: counters[2].value, duration: 10 });
  const { countUp: countThree } = useCountUp({ end: counters[1].value, duration: 12 });
  const { countUp: countTwo } = useCountUp({ end: counters[0].value, duration: 10 });

  return (
    <div className='home-counter'>
      <div className='d-flex justify-content-between counterContent'>
        <div className='counter d-flex flex-column flex-md-row'>
          <FaCheck className='counter-icon' />
          <div className='right'>
            <h2>
              {countOne} {counters[2].extension}
            </h2>
            <p> {counters[2].name}</p>
          </div>
        </div>
        <div className='counter d-flex flex-column flex-md-row'>
          <FaCheck className='counter-icon' />
          <div className='right'>
            <h2>
              {countThree} {counters[1].extension}
            </h2>
            <p> {counters[1].name} </p>
          </div>
        </div>
        <div className='counter d-flex flex-column flex-md-row'>
          <FaCheck className='counter-icon' />
          <div className='right'>
            <h2>
              {countTwo} {counters[0].extension}
            </h2>
            <p> {counters[0].name} </p>
          </div>
        </div>
      </div>
    </div>
  );
};
